module.exports = __webpack_public_path__ + "static/3-f7d057c7e11deeccda342cc7108155bd.jpeg";